import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["refresh", "fallback", "error"];

  connect() {
    this.fallbackTargets.forEach((button) => {
      button.hidden = true;
    });
  }

  disconnect() {
    this.request?.abort();
  }

  selectDays(event) {
    event.preventDefault();
    const button = event.currentTarget;
    const checked = button.value.startsWith("select_all_days:");
    button
      .closest("[data-schedule-block]")
      .querySelectorAll('input[type="checkbox"][name$="[weekdays][]"]')
      .forEach((input) => {
        input.checked = checked;
      });
  }

  async refresh(event) {
    if (this.request) return;

    const field = event.target;
    const top = field.getBoundingClientRect().top;
    const data = new FormData(this.element, this.refreshTarget);
    data.set(this.refreshTarget.name, this.refreshTarget.value);
    const controls = Array.from(this.element.elements).filter((control) => !control.disabled);
    this.request = new AbortController();
    this.element.setAttribute("aria-busy", "true");
    this.errorTarget.hidden = true;
    controls.forEach((control) => {
      control.disabled = true;
    });

    try {
      const response = await fetch(this.refreshTarget.formAction, {
        method: this.element.method,
        body: data,
        headers: { Accept: "text/html" },
        signal: this.request.signal,
      });
      if (!response.ok || response.redirected) throw new Error("Dose preview failed");

      const document = new DOMParser().parseFromString(await response.text(), "text/html");
      const replacement = document.getElementById(this.element.id);
      if (!replacement) throw new Error("Dose preview form is missing");
      replacement.querySelectorAll('[data-protocol-editor-target~="fallback"]').forEach((button) => {
        button.hidden = true;
      });

      this.element.replaceWith(replacement);
      const nextField = Array.from(replacement.elements).find((control) => control.id === field.id);
      if (nextField) {
        nextField.focus({ preventScroll: true });
        const main = replacement.closest("main");
        const scrollContainer =
          main && ["auto", "scroll"].includes(window.getComputedStyle(main).overflowY) ? main : window;
        scrollContainer.scrollBy(0, nextField.getBoundingClientRect().top - top);
      }
    } catch (error) {
      if (error.name !== "AbortError") {
        this.fallbackTargets.forEach((button) => {
          button.hidden = false;
        });
        this.errorTarget.hidden = false;
        this.errorTarget.focus();
      }
    } finally {
      controls.forEach((control) => {
        control.disabled = false;
      });
      this.element.removeAttribute("aria-busy");
      this.request = null;
    }
  }
}
